import React from 'react';
import { Query } from 'react-apollo';

import query from './ProviderPageQuery.graphql';

export default function ProviderPageQuery({ children, providerId }) {
  return (
    <Query query={query} variables={{ id: providerId }}>
      {({ data, loading, error }) => {
        if (error || loading || !data) {
          return children({
            error,
            loading,
            provider: undefined,
          });
        }

        const { provider } = data;

        return children({
          error,
          loading,
          provider,
        });
      }}
    </Query>
  );
}
